import React from "react";
import { General } from "../tools/styles"
import FloatCard from "./ui/FloatCard";
import { theme } from "../theme";
import RenderIf from "./RenderIf";

const Concerns = ({
  currentConcern = false,
  futureConcern = false,
  metric = "",
}) => {
  return (
    <General.BlockContainer>
      <General.Block>
        <FloatCard width="300px">
          {/* There is a concern now */}
          <RenderIf isTrue={currentConcern}>
            <General.InputCont>
            <General.BoldPara>
                {metric} currently falls outside the healthy range of values.
              </General.BoldPara>
            </General.InputCont>
          </RenderIf>
          {/* There is no current concern */}
          <RenderIf isTrue={!currentConcern}>
            <General.InputCont>
              <p>
                {metric} currently falls within the healthy range of values.
              </p>
            </General.InputCont>
          </RenderIf>
          {/* There will be a concern in the future */}
          <RenderIf isTrue={futureConcern}>
            <General.InputCont>
              <General.BoldPara>
              {metric} is forecast to fall outside the healthy range of values.
              </General.BoldPara>
            </General.InputCont>
          </RenderIf>
          <RenderIf isTrue={!futureConcern}>
            <General.InputCont>
              <p>
                {metric} is forecast to fall within the healthy range of values.
              </p>
            </General.InputCont>
          </RenderIf>
        </FloatCard>
      </General.Block>
      <General.Block color={theme.colors.grey4}>
        <h2>Concerns</h2>
      </General.Block>
    </General.BlockContainer>
  );
};

export default Concerns;
